import { $brandProfile, $brandProfileAssets } from './states';
import { fetchBrandProfile, fetchBrandProfileAssets, updateBrandProfileInformation } from './effects';

// Brand profile
$brandProfile.on(fetchBrandProfile.doneData, (_, data) => data);

// Brand profile assets
$brandProfileAssets.on(fetchBrandProfileAssets.doneData, (_, data) => data);
